var map = {
	"./_gcse-science-figures-manifest.json": 8697,
	"./_gcse-science-question-cards-manifest.json": 3520,
	"./biology/AQA-84641B1H/q01-fig-a.meta.json": 620,
	"./biology/AQA-84641B1H/q02-2-fig-a.meta.json": 7882,
	"./biology/AQA-84641B1H/q02-3-graph-a.meta.json": 3605,
	"./biology/AQA-84641B1H/q03-2-graph-a.meta.json": 9305,
	"./biology/AQA-84641B1H/q03-table-a.meta.json": 9388,
	"./biology/AQA-84641B1H/q04-1-graph-a.meta.json": 7709,
	"./biology/AQA-84641B1H/q06-3-diagram-a.meta.json": 3430,
	"./biology/AQA-84641B1H/q07-fig-a.meta.json": 2338,
	"./biology/AQA-84642B2H/q01-diagram-a.meta.json": 7905,
	"./biology/AQA-84642B2H/q04-diagram-a.meta.json": 9444,
	"./biology/AQA-84642B2H/q04-diagram-b.meta.json": 3595,
	"./biology/AQA-84642B2H/q04-graph-a.meta.json": 7471,
	"./biology/AQA-84642B2H/q06-diagram-a.meta.json": 4422,
	"./biology/AQA-84642B2H/q09-diagram-a.meta.json": 5449,
	"./biology/AQA-84642B2H/q09-diagram-b.meta.json": 4846,
	"./biology/AQA-84642B2H/q09-graph-a.meta.json": 4670,
	"./biology/biology-mcqs.json": 1425,
	"./biology/fact-cards/b1-fact-cards.json": 9848,
	"./biology/fact-cards/b2-fact-cards.json": 9751,
	"./biology/fact-cards/b3-fact-cards.json": 7886,
	"./biology/fact-cards/b4-fact-cards.json": 4757,
	"./biology/fact-cards/b5-fact-cards.json": 7116,
	"./biology/fact-cards/b6-fact-cards.json": 2251,
	"./biology/fact-cards/b7-fact-cards.json": 2818,
	"./biology/questions/biology/AQA-84641B1H-paper.json": 350,
	"./biology/questions/biology/AQA-84641B1H-questions.json": 6129,
	"./biology/questions/biology/AQA-84642B2H-paper.json": 3402,
	"./biology/questions/biology/AQA-84642B2H-questions.json": 4733,
	"./biology/questions/biology/AQA-8464B1H-JUN18-paper.json": 2892,
	"./biology/questions/biology/AQA-8464B1H-JUN18-questions.json": 2299,
	"./biology/questions/biology/AQA-8464B2H-JUN18-paper.json": 1147,
	"./biology/questions/biology/AQA-8464B2H-JUN18-questions.json": 2056,
	"./biology/questions/biology/AQA-8464B2H-JUN19-paper.json": 3228,
	"./biology/questions/biology/AQA-8464B2H-JUN19-questions.json": 891,
	"./biology/questions/biology/AQA-8464B2H-JUN22-paper.json": 98,
	"./biology/questions/biology/AQA-8464B2H-JUN22-questions.json": 3093,
	"./biology/questions/biology/AQA-8464B2H-JUN23-paper.json": 3705,
	"./biology/questions/biology/AQA-8464B2H-JUN23-questions.json": 1698,
	"./biology/questions/biology/AQA-8464B2H-JUN24-paper.json": 4040,
	"./biology/questions/biology/AQA-8464B2H-JUN24-questions.json": 8359,
	"./biology/questions/biology/AQA-8464B2H-NOV20-paper.json": 7102,
	"./biology/questions/biology/AQA-8464B2H-NOV20-questions.json": 1537,
	"./biology/questions/biology/AQA-8464B2H-NOV21-paper.json": 8085,
	"./biology/questions/biology/AQA-8464B2H-NOV21-questions.json": 526,
	"./chemistry/AQA-84643C1H/q01-3-fig-a.meta.json": 9626,
	"./chemistry/AQA-84643C1H/q02-2-graph-a.meta.json": 9486,
	"./chemistry/AQA-84643C1H/q02-2-table-a.meta.json": 5354,
	"./chemistry/AQA-84643C1H/q02-fig-a.meta.json": 7045,
	"./chemistry/AQA-84643C1H/q03-2-fig-a.meta.json": 873,
	"./chemistry/AQA-84643C1H/q05-1-chem-a.meta.json": 2407,
	"./chemistry/AQA-84643C1H/q06-1-graph-a.meta.json": 321,
	"./chemistry/AQA-84643C1H/q06-2-chem-a.meta.json": 1695,
	"./chemistry/AQA-84643C1H/q06-2-table-a.meta.json": 4942,
	"./chemistry/AQA-84643C1H/q06-3-fig-a.meta.json": 7185,
	"./chemistry/AQA-84643C1H/q06-4-table-a.meta.json": 3624,
	"./chemistry/AQA-84644C2H/q01-4-diagram-a.meta.json": 9452,
	"./chemistry/AQA-84644C2H/q01-4-graph-a.meta.json": 4519,
	"./chemistry/AQA-84644C2H/q01-diagram-a.meta.json": 9539,
	"./chemistry/AQA-84644C2H/q02-4-table-a.meta.json": 6164,
	"./chemistry/AQA-84644C2H/q03-1-diagram-a.meta.json": 2495,
	"./chemistry/AQA-84644C2H/q03-2-diagram-a.meta.json": 196,
	"./chemistry/AQA-84644C2H/q03-3-graph-a.meta.json": 4706,
	"./chemistry/AQA-84644C2H/q03-4-table-a.meta.json": 8101,
	"./chemistry/AQA-84644C2H/q03-5-graph-a.meta.json": 6528,
	"./chemistry/AQA-84644C2H/q04-3-chemical_structure-a.meta.json": 6107,
	"./chemistry/AQA-84644C2H/q05-1-diagram-a.meta.json": 4509,
	"./chemistry/AQA-84644C2H/q06-3-graph-a.meta.json": 6247,
	"./chemistry/chemistry-mcqs.json": 517,
	"./chemistry/fact-cards/c1-fact-cards.json": 104,
	"./chemistry/fact-cards/c10-fact-cards.json": 8406,
	"./chemistry/fact-cards/c2-fact-cards.json": 1239,
	"./chemistry/fact-cards/c3-fact-cards.json": 430,
	"./chemistry/fact-cards/c4-fact-cards.json": 6869,
	"./chemistry/fact-cards/c5-fact-cards.json": 1084,
	"./chemistry/fact-cards/c6-fact-cards.json": 1291,
	"./chemistry/fact-cards/c7-fact-cards.json": 7922,
	"./chemistry/fact-cards/c8-fact-cards.json": 4713,
	"./chemistry/fact-cards/c9-fact-cards.json": 7200,
	"./chemistry/questions/chemistry/AQA-84643C1H-questions.json": 1176,
	"./chemistry/questions/chemistry/AQA-84644C2H-questions.json": 9480,
	"./chemistry/questions/chemistry/AQA-8464C1H-JUN18-paper.json": 8283,
	"./chemistry/questions/chemistry/AQA-8464C1H-JUN18-questions.json": 1704,
	"./chemistry/questions/chemistry/AQA-8464C2H-JUN18-paper.json": 2444,
	"./chemistry/questions/chemistry/AQA-8464C2H-JUN18-questions.json": 5947,
	"./chemistry/questions/chemistry/AQA-8464C2H-JUN19-paper.json": 363,
	"./chemistry/questions/chemistry/AQA-8464C2H-JUN19-questions.json": 3464,
	"./chemistry/questions/chemistry/AQA-8464C2H-JUN22-paper.json": 2777,
	"./chemistry/questions/chemistry/AQA-8464C2H-JUN22-questions.json": 514,
	"./chemistry/questions/chemistry/AQA-8464C2H-JUN23-paper.json": 3618,
	"./chemistry/questions/chemistry/AQA-8464C2H-JUN23-questions.json": 8645,
	"./chemistry/questions/chemistry/AQA-8464C2H-JUN24-paper.json": 2743,
	"./chemistry/questions/chemistry/AQA-8464C2H-JUN24-questions.json": 5652,
	"./chemistry/questions/chemistry/AQA-8464C2H-NOV20-paper.json": 8673,
	"./chemistry/questions/chemistry/AQA-8464C2H-NOV20-questions.json": 1210,
	"./chemistry/questions/chemistry/AQA-8464C2H-NOV21-paper.json": 5482,
	"./chemistry/questions/chemistry/AQA-8464C2H-NOV21-questions.json": 77,
	"./physics/AQA-84645P1H/q01-diagram-a.meta.json": 4289,
	"./physics/AQA-84645P1H/q01-diagram-b.meta.json": 4022,
	"./physics/AQA-84645P1H/q01-graph-a.meta.json": 9014,
	"./physics/AQA-84645P1H/q02-diagram-a.meta.json": 5882,
	"./physics/AQA-84645P1H/q02-diagram-b.meta.json": 8741,
	"./physics/AQA-84645P1H/q02-table-a.meta.json": 5429,
	"./physics/AQA-84645P1H/q03-diagram-a.meta.json": 1763,
	"./physics/AQA-84645P1H/q05-diagram-a.meta.json": 5229,
	"./physics/AQA-84645P1H/q05-graph-a.meta.json": 8834,
	"./physics/AQA-84645P1H/q05-table-a.meta.json": 3774,
	"./physics/AQA-84645P1H/q06-diagram-a.meta.json": 166,
	"./physics/AQA-84646P2H/q01-5-table-a.meta.json": 6992,
	"./physics/AQA-84646P2H/q01-6-graph-a.meta.json": 7227,
	"./physics/AQA-84646P2H/q01-table-a.meta.json": 1770,
	"./physics/AQA-84646P2H/q03-5-diagram-a.meta.json": 9373,
	"./physics/AQA-84646P2H/q03-diagram-a.meta.json": 2011,
	"./physics/AQA-84646P2H/q04-graph-a.meta.json": 5511,
	"./physics/AQA-84646P2H/q05-1-diagram-a.meta.json": 5131,
	"./physics/AQA-84646P2H/q05-4-graph-a.meta.json": 153,
	"./physics/AQA-84646P2H/q05-diagram-a.meta.json": 2181,
	"./physics/AQA-84646P2H/q06-diagram-a.meta.json": 9246,
	"./physics/fact-cards/p1-fact-cards.json": 9876,
	"./physics/fact-cards/p2-fact-cards.json": 9315,
	"./physics/fact-cards/p3-fact-cards.json": 9530,
	"./physics/fact-cards/p4-fact-cards.json": 7337,
	"./physics/fact-cards/p5-fact-cards.json": 8992,
	"./physics/fact-cards/p6-fact-cards.json": 6287,
	"./physics/fact-cards/p7-fact-cards.json": 4326,
	"./physics/physics-mcqs.json": 9141,
	"./physics/questions/physics/AQA-84645P1H-paper.json": 2556,
	"./physics/questions/physics/AQA-84645P1H-questions.json": 6331,
	"./physics/questions/physics/AQA-84646P2H-paper.json": 3156,
	"./physics/questions/physics/AQA-84646P2H-questions.json": 5123,
	"./physics/questions/physics/AQA-8464P2H-JUN22-paper.json": 7608,
	"./physics/questions/physics/AQA-8464P2H-JUN22-questions.json": 9015,
	"./physics/questions/physics/AQA-8464P2H-JUN23-paper.json": 1943,
	"./physics/questions/physics/AQA-8464P2H-JUN23-questions.json": 980,
	"./physics/questions/physics/AQA-8464P2H-JUN24-paper.json": 9490,
	"./physics/questions/physics/AQA-8464P2H-JUN24-questions.json": 8485,
	"./physics/questions/physics/AQA-8464P2H-NOV20-paper.json": 1828,
	"./physics/questions/physics/AQA-8464P2H-NOV20-questions.json": 1811,
	"./physics/questions/physics/AQA-8464P2H-NOV21-paper.json": 419,
	"./physics/questions/physics/AQA-8464P2H-NOV21-questions.json": 8304,
	"./psychology-mcq-bank.json": 4565,
	"./psychology/past-papers/paper1-2022.json": 6136,
	"./psychology/past-papers/paper1-2023.json": 75,
	"./psychology/past-papers/paper1-2024.json": 2038
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1491;